<template>
    <app-content-admin>
        <template slot="header">{{ $t("edit_banner") }}</template>
        <template slot="back">
            <v-btn small @click="$router.push({name: 'banner'})" color="primary">Back</v-btn>
        </template>

        <v-container>
            <v-form ref="form" lazy-validation v-model="valid" @submit.prevent="submit">
                <v-card class="px-5 mx-auto" max-width="900px">
                    <v-card-title>Banner Details</v-card-title>
                    
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">                            
                                <v-text-field
                                    v-model="form.title"
                                    label="Title"
                                    outlined
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12">
                                <v-textarea
                                    v-model="form.description"
                                    outlined
                                    label="Description"
                                ></v-textarea>
                            </v-col>

                            <v-col cols="12">
                                <label>{{ $t('image')}}</label>
                                <v-hover v-slot="{ hover }" v-if="!changeImage">
                                    <v-card max-width="1366" flat>
                                        <v-img class="align-center justify-center" 
                                            
                                            :src="form.image"
                                            cover
                                        >
                                            <v-expand-transition>
                                                <div
                                                    v-if="hover"
                                                    class="d-flex transition-fast-in-fast-out v-card--reveal justify-center"
                                                    style="height: 100%;"
                                                >
                                                    <v-btn small color="error" @click="changeImage = !changeImage">Delete</v-btn>
                                                </div>
                                            </v-expand-transition>
                                        </v-img>
                                    </v-card>
                                </v-hover>

                                <vue-dropzone
                                    v-else
                                    id="image"
                                    ref="image"
                                    @vdropzone-success="uploadCallback"                                
                                    :options="dropzone_option"
                                    @vdropzone-removed-file="removedCallback">
                                </vue-dropzone>
                            </v-col>

                            <v-col cols="12">
                                <v-switch
                                    v-model="form.is_active"
                                    label="Enable Banner"
                                ></v-switch>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" type="submit">Submit</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-container>
    </app-content-admin>
</template>

<script>
import vForm from '@/mixins/vForm';
import Dropzone from '@/mixins/Dropzone'

export default {
    name: 'banner_edit',
    mixins: [vForm, Dropzone],
    
    data() {
        return {
            form: {
                is_active: 1,
                title: '',
                description: '',
                files: [],
            },
            dropzone_option: this.dropzoneOptions('image', api.path('banner.upload')),

            changeImage: false,
        }
    },

    created() {
        this.getBanner();
    },

    methods: {
        async getBanner() {
            console.log('okokook mou');
            await axios.get(api.path('banner.detail', {id: this.$route.params.id}))
                .then(res => res.data)
                    .then(res => {
                        this.form = res.data;
                        this.form.files = [];
                        this.form.image = res.data.image.path

                        console.log(res.data);
                    })
        },
        
        async submit() {
            let loader = this.$loading.show();

            await axios.post(api.path('banner.update'), this.form)
            .then(res => res.data)
                .then(res =>  {
                    this.$toastr.s(this.$t(res.message));
                    this.getBanner();
                    this.changeImage = false;
                    loader.hide();
            })
            .catch(error => {                
                this.$toastr.e(error.response.data.message);
                loader.hide();
            });

            loader.hide();
        },
    }
}
</script>
<style lang="">
    
</style>